import { render, staticRenderFns } from "./SystemPie.vue?vue&type=template&id=5c1983fb&scoped=true"
import script from "./SystemPie.vue?vue&type=script&lang=js"
export * from "./SystemPie.vue?vue&type=script&lang=js"
import style0 from "./SystemPie.vue?vue&type=style&index=0&id=5c1983fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1983fb",
  null
  
)

export default component.exports